module.exports = __webpack_public_path__ + "img/BA.0e13c826.png";